<template>
  <div class="nav">
      <div class="item">
        <img :src="navList[1].img" alt="" />
        <div class="btn-group">
          <div class="btn primary" @click="handlePrimaryClick">立即办理</div>
          <div class="btn secondary" @click="handleSecondaryClick">火化证明</div>
        </div>
      </div>
  </div>


</template>

<script>
export default {
  components: {},
  props: ["navList"],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {

    handlePrimaryClick() {
      this.$router.push("/oneThing");
    },
    handleSecondaryClick() {
      this.$router.push("/myMatters");
    },
    toHome(e) {
      if(e.path == '/'){
        this.$alert('正在开发中，敬请期待', '提示', {
          confirmButtonText: '确定',
        });
      }
      // this.$emit("toHome", e);
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.nav {
  .item {
    height: 231px;
    border-radius: 20px;
    position: relative;
    margin: 20px 0;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }

    // ✅ 新增：按钮组，左右排列两个按钮
    .btn-group {
      position: absolute;
      left: 48px;    // 距离左边
      bottom: 26px;  // 距离底部
      display: flex;
      gap: 16px;     // 按钮之间的间距
      width: fit-content;
      justify-content: center;
    }

    .btn {
      width: 206px;
      height: 62px;
      border-radius: 31px;
      font-size: 30px;
      font-weight: bold;
      line-height: 62px;
      text-align: center;
      cursor: pointer;
      flex: 0 0 auto;
    }

    .btn.primary {
      background-color: #0786FE;
      color: #ffffff;
      border: 10px solid #0786FE;
    }

    .btn.secondary {
      background-color: #0786FE;
      color: #ffffff;
      border: 10px solid #0786FE;
    }
  }
}
</style>
